import ComputerInterface from "@/interfaces/Computer.interface";
import api from "@/services/config";

export class ComputerRest {
  getComputers(params: any): Promise<any> {
    return api.get("/computer", { params }).then((response) => response.data);
  }

  getComputerById(id: any): Promise<any> {
    return api.get(`/computer/${id}`).then((response) => response.data);
  }

  addComputer(data: any): Promise<any> {
    return api.post("/computer", data).then((response) => response.data);
  }

  updateComputer(id: any, data: ComputerInterface): Promise<any> {
    return api.put(`/computer/${id}`, data).then((response) => response.data);
  }

  deleteComputer(id: any): Promise<ComputerInterface> {
    return api.delete(`/computer/${id}`).then((response) => response.data);
  }

  getComputersAvailable(data: any): Promise<any> {
    return api
      .post(`/computer/available/group`, data)
      .then((response) => response.data);
  }

  getComputersAvailableSchedule(data: any): Promise<any> {
    return api
      .post(`/computer/available/schedule`, data)
      .then((response) => response.data);
  }
  getComputersAvailableList(params: any): Promise<any> {
    return api
      .get("/computer/list-available", { params })
      .then((response) => response.data);
  }
}
